module.exports = __webpack_public_path__ + "LatoLatin-ThinItalic.d1732910c26d17634be6.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-ThinItalic.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-ThinItalic.eot
// module chunks = styles